import {
  Briefcase,
  BriefcaseBusiness,
  Building,
  Building2,
  Calendar,
  CircleCheck,
  Link,
  Linkedin,
  Mail,
  MailCheck,
  MapPin,
  Phone,
  PhoneCall,
  Shapes,
  ShieldCheck,
  Trash,
  Type,
  User,
  UserCheck,
  Zap,
  type LucideIcon,
} from 'lucide-react';

export const FIELD_ICONS: Record<string, LucideIcon> = {
  contact_id: User,
  icp_id: Building,
  persona_id: UserCheck,
  location: MapPin,
  created_at: Calendar,
  updated_at: Calendar,
  signal_at: Calendar,
  executed_at: Calendar,
  url: Link,
  status: CircleCheck,
  email: Mail,
  user_email: Mail,
  has_email: MailCheck,
  has_verified_email: ShieldCheck,
  has_linkedin: Linkedin,
  has_phone: Phone,
  has_verified_phone: PhoneCall,
  is_persona: UserCheck,
  is_deleted: Trash,
  name: Type,
  title: BriefcaseBusiness,
  company_domain: Building2,
  role: Briefcase,
  type: Shapes,
  action: Zap,
};
